import {Breakpoints} from '@angular/cdk/layout';
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {BehaviorSubject, NEVER} from 'rxjs';

import {
  BaseTableComponent,
  makeQueryBuilder,
  makeQueryRules,
  TableField,
  TableFilterType,
  TableSelection,
  TableSortType,
  UiTableComponent,
} from '@ui/ui.module';

import {BaseApiService, SwalService} from '@atmi/core';
import {Base, BaseFilter, BaseFilterMeta, SourceArchivial} from '@atmi/core/models';
import {BaseFiltersComponent} from '@atmi/shared/filters/base-filters/base-filters.component';

import {AddBaseDialogComponent} from '@atmi/shared/add-base-dialog/add-base-dialog.component';
import {tap} from "rxjs/operators";

export interface BaseDialogData {
  basi: Base[];
}

@Component({
  selector: 'app-base-picker-dialog',
  styleUrls: ['./base-picker-dialog.component.scss'],
  templateUrl: './base-picker-dialog.component.html',
})
export class BasePickerDialogComponent
  extends BaseTableComponent<Base>
  implements UiTableComponent<Base> {

  protected paginationStore: 'route' | 'local' | 'none' = 'local';

  readonly MobileFiltersComponent = BaseFiltersComponent;

  readonly filters$ = new BehaviorSubject<TableFilterType | undefined>(undefined);

  readonly fields: TableField<Base>[] = [
    {
      header: '',
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'chekbox',
      selectable: true,
    },
    {
      header: this.translate.instant('Codice unico'),
      key: 'codiceUnico',
      sortable: true,
    },
    {
      header: this.translate.instant('Titolo'),
      key: 'titolo',
      sortable: true,
    },
    {
      context: (x) => x.tag ? x.tag.slice(0, 5).join(', ') : '',
      header: this.translate.instant('Tags'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'tags',
    },
    {
      header: this.translate.instant('Data creazione'),
      hideBreakpoints: [Breakpoints.XSmall, Breakpoints.Small],
      key: 'createdAt',
      sortable: true,
      template: 'date-time',
    },
  ];

  readonly pager$ = (page?: number, limit?: number, sort?: TableSortType, filter?: TableFilterType) => {
    const obs = this.baseApi.index({sort, page, limit, filter});
    return obs
  }


  readonly title = this.translate.instant('Aggiungi base');

  readonly mainActionLabel = this.translate.instant('Collega');


  constructor(
    public dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<BasePickerDialogComponent>,
    private readonly baseApi: BaseApiService,
    protected readonly translate: TranslateService,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly swalService: SwalService,
    @Inject(MAT_DIALOG_DATA) public readonly data: BaseDialogData,
  ) {
    super(translate, router, route, swalService, 'local');

  }

  applyFilterWithDelayHandler(filters: BaseFilter) {
    const rules = makeQueryRules(filters, BaseFilterMeta);
    const query = makeQueryBuilder(rules);

    this.filters$.next(query);
  }

  completeHandler() {
    const selectedBase = this.selectedItems[0];
    if (this.data.basi.find(x => x.id === selectedBase.id)) {
      this.swalService.showError({title: 'Errore', text: this.translate.instant('La base è già presente')});
      this.selectedItems = [];
    } else {
      this.dialogRef.close(selectedBase);
    }

  }

  selectHandler(selectedBase: TableSelection<Base>) {
    super.selectHandler(selectedBase);
  }

  closeHandler() {
    this.dialogRef.close();
  }

  deleteConcreteHandler() {
    return NEVER;
  }

  deleteSelectedConcreteHandler() {
    return NEVER;
  }

  handleCreateAndAdd() {
    const data = {};
    const dialogRef = this.dialog.open(AddBaseDialogComponent, {
      width: '70vw',
      height: '80vh',
      data
    });

    dialogRef.afterClosed().subscribe((result: Base | undefined) => {
      this.dialogRef.close(result);
    });
  }
}
